export default "__VITE_ASSET__BfnYkK_s__"